const selectors = [
'[aria-label="Book My Consultation"]',
'[aria-label="Prendre Rendez-vous Maintenant"]',
'[aria-label="Make an appointment"]',
'[aria-label="Prendre rendez-vous"]',
'[aria-label="Faites votre demande maintenant"]',
'[aria-label="Book your 6-month application today"]',
'[aria-label="Faites votre demande maintenant"]',
'[aria-label="Réserver ma consultation"]',
"[aria-label=\"Réservez votre pose de 6 mois dès aujourd'hui\"]",
'.apply-now-btn',
'.ah-header-hero__button'
];

document.addEventListener('click', function (e) {
    if (e.target.closest(selectors.join(','))) {
        fbq('track', 'lead');
        console.log('Lead event fired');
    }
});

console.log('hello')